import {createSelector} from '@ngrx/store';
import {AppState} from '../state/app.state';
import {UserState} from '../state/user.state';
import {StorageState} from "@store/state/storage.state";

export const selectStorage = (state: AppState) => state.storage;
export const selectUser = (state: AppState) => state.user;

export const getSelectedCustomer = createSelector(
    selectUser,
    selectStorage,
    (user: UserState, storage: StorageState) => user.mappedCustomers?.filter(customer => customer.id == storage.customer?.id)[0]
);

export const isCustomerRegistered = createSelector(
    selectUser,
    selectStorage,
    (user: UserState, storage: StorageState) => {
        if (user.mappedCustomers?.filter(customer => customer.id == storage.customer?.id)[0]) {
            return user.mappedCustomers?.filter(customer => customer.id == storage.customer?.id)[0].guest
        }
        return false;
    }
);

export const getMappedCustomer = createSelector(
    selectUser,
    (user: UserState) => user.mappedCustomers
);

export const getSelectedBillingAddress = createSelector(
    selectUser,
    selectStorage,
    (user: UserState, storage: StorageState) => {
        const customer = user.mappedCustomers?.filter(customer => customer.id == storage.customer?.id)[0];
        if (customer) {
            const address = customer.addresses.filter(a => a.addressId == storage.customer?.selectedBillingAddressId)[0];
            // Keine Adresse ausgewählt. Erste Adresse wählen.
            if (!address &&
                customer.addresses[0]) {
                return customer.addresses[0];
            } else if (address) {
                return address;
            }
        }
        return undefined;
    }
);

export const getSelectedDeliveryAddress = createSelector(
    selectUser,
    selectStorage,
    (user: UserState, storage: StorageState) => {
        const customer = user.mappedCustomers?.filter(customer => customer.id == storage.customer?.id)[0];
        if (customer) {
            if (storage.customer?.selectedDeliveryAddressId) {
                const address = customer.addresses.filter(a => a.addressId == storage.customer?.selectedDeliveryAddressId)[0];
                if (address) {
                    return address;
                }
            }
        }
        return undefined;
    }
);
